<div class="error-container" [style.height]="height">
  <mat-icon class="error-icon">{{ icon }}</mat-icon>
  <p class="error-message">{{ message }}</p>
</div>




